require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./relazioni-e-conferenze-riccardo-bergossi-rino-tami-e-il-progetto-per-l-arsenale-di-biasca-biasca-12-giugno-2019.json") })
        }
      }, "path---relazioni-e-conferenze-riccardo-bergossi-rino-tami-e-il-progetto-per-l-arsenale-di-biasca-biasca-12-giugno-2019");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---relazioni-e-conferenze-riccardo-bergossi-rino-tami-e-il-progetto-per-l-arsenale-di-biasca-biasca-12-giugno-2019!./.cache/json/relazioni-e-conferenze-riccardo-bergossi-rino-tami-e-il-progetto-per-l-arsenale-di-biasca-biasca-12-giugno-2019.json
// module id = 739
// module chunks = 231608221292675